import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c15cd03c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nv-period-badge" }
const _hoisted_2 = { class: "nv-period-badge-month" }
const _hoisted_3 = { class: "nv-period-badge-days" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.43451 3.43353C3.74693 3.12111 4.25346 3.12111 4.56588 3.43353L8.0002 6.86785L11.4345 3.43353C11.7469 3.12111 12.2535 3.12111 12.5659 3.43353C12.8783 3.74595 12.8783 4.25248 12.5659 4.5649L9.13157 7.99922L12.5659 11.4335C12.8783 11.746 12.8783 12.2525 12.5659 12.5649C12.2535 12.8773 11.7469 12.8773 11.4345 12.5649L8.0002 9.13059L4.56588 12.5649C4.25346 12.8773 3.74693 12.8773 3.43451 12.5649C3.12209 12.2525 3.12209 11.746 3.43451 11.4335L6.86882 7.99922L3.43451 4.5649C3.12209 4.25248 3.12209 3.74595 3.43451 3.43353Z",
  fill: "#64748B"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.badgeDates, (badgeDate, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "nv-period-badge-content",
        key: `badge-date-${i}`
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(badgeDate.monthName) + " " + _toDisplayString(badgeDate.year), 1),
        _createElementVNode("div", _hoisted_3, [
          (badgeDate.endDay)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(badgeDate.day) + " - " + _toDisplayString(badgeDate.endDay), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(badgeDate.day), 1)
              ], 64))
        ])
      ]))
    }), 128)),
    (_ctx.deletable)
      ? (_openBlock(), _createElementBlock("svg", {
          key: 0,
          class: "cursor-pointer",
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onDelete && _ctx.onDelete(...args)))
        }, _hoisted_5))
      : _createCommentVNode("", true)
  ]))
}